import React, { useEffect, useState } from "react";
import {
  PieChart,
  Pie,
  Tooltip,
  Cell,
  ResponsiveContainer,
} from "recharts";
import styles from "./statistic.module.css";
import StatisticFormat from "components/statisticFormat/statisticFormat";
import { statistic10 } from "services/statistic/statistic10";
import { generateCSVContent, downloadFile } from "utils/statistic";

interface FacultyData10 {
  faculty: string;
  total_bookings: number;
}

interface YearData10 {
  year: string;
  faculties: FacultyData10[];
}

export default function Statistic10statistic10() {
  const [data, setData] = useState<YearData10[]>([]);
  const [selectedYear, setSelectedYear] = useState<string | null>(null);
  const [chartData, setChartData] = useState<FacultyData10[]>([]);

  const fetchData = async () => {
    try {
      const res = await statistic10();
      const { data } = res;

      const formattedData: YearData10[] = Object.keys(data).map((year) => ({
        year,
        faculties: Object.keys(data[year]).map((faculty) => ({
          faculty,
          total_bookings: parseInt(data[year][faculty], 10),
        })),
      }));

      setData(formattedData);

      if (formattedData.length > 0) {
        setSelectedYear(formattedData[formattedData.length -1].year);
        setChartData(formattedData[0].faculties);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleYearChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const year = event.target.value;
    setSelectedYear(year);

    const yearData = data.find((d) => d.year === year);
    setChartData(yearData ? yearData.faculties : []);
  };
  const downloadCSV = () => {
    const headers = ['Faculty', 'Total Bookings', 'Percentage'];
  
    const rows: (string | number)[][] = chartData.map((entry) => {
      const percentage = ((entry.total_bookings / totalBookings) * 100).toFixed(1);
      return [
        entry.faculty, 
        entry.total_bookings, 
        percentage,
      ];
    });
    const csvContent = generateCSVContent(headers, rows);
    downloadFile(csvContent, "Anlage5b.csv");
  };
  
  useEffect(() => {
    fetchData();
  }, []);

  const COLORS = ["#5b9cd4", "#ee7e32", "#9f9f9f", "#ffc100", "#4272cc", "#6fae46"];

  const totalBookings = chartData.reduce((sum, item) => sum + item.total_bookings, 0);

  return (
    <StatisticFormat label="" description="" onButton1Click={downloadCSV}>
      <div className={styles.container}>
      <div className={styles.selectField}>
          <label htmlFor="year-select">Jahr auswählen:</label>
          <select
            id="year-select"
            value={selectedYear || ""}
            onChange={handleYearChange}
          >
            {data.map((item) => (
              <option key={item.year} value={item.year}>
                {item.year}
              </option>
            ))}
          </select>
        </div>

        <div className={styles.chartTitle}>
          <h3>{selectedYear} - Fakultäten Buchungen</h3>
        </div>

          <ResponsiveContainer width="100%" height={390}>
            <PieChart  style={{ maxHeight: "380px" }}>
              <Pie
             
                data={chartData}
                dataKey="total_bookings"
                nameKey="faculty"
                cx="50%"
                cy="50%"
                outerRadius={150}
                fill="#8884d8"
                
                label={({ faculty, total_bookings }) =>
                  `${faculty}: ${((total_bookings / totalBookings) * 100).toFixed(1)}%`
                }
              >
                {chartData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip
               
                formatter={(value: number) => `${value} Buchungen`}
                labelFormatter={(name: string) => `Fakultät: ${name}`}
              />
            </PieChart>
          </ResponsiveContainer>
      </div>
    </StatisticFormat>
  );
}
